import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type Props = {
  eyebrow?: string;
  title: ReactNode;
  description?: ReactNode;
  className?: string;
  align?: 'left' | 'center';
};

export function SectionHeading({
  eyebrow,
  title,
  description,
  className,
  align = 'left',
}: Props) {
  return (
    <header
      className={cn('flex flex-col gap-5', align === 'center' && 'items-center text-center', className)}
    >
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2 className="display-lg max-w-4xl">{title}</h2>
      {description && (
        <p className="text-lg text-ink-secondary max-w-2xl leading-relaxed">{description}</p>
      )}
    </header>
  );
}
